/*
 * Painting offer: the page side of the shopper-facing surfaces.
 *
 * Liquid renders every state, hidden. CSS shows the one that matches
 * <html data-offer-arm> (set by the arm snippet) and <html data-offer-n>
 * (the painting count, first set by Liquid). This script never draws or changes the arm and never builds markup.
 * It only:
 *   1. keeps data-offer-n in step with the cart, after every
 *      `side-cart:updated`;
 *   2. opens and closes the "How it works" sheet;
 *   3. sends a collection tile tap to the sheet (cart empty) or the side cart.
 *
 * Later surfaces use window.omdOffer: `n` (paintings in the cart), `arm()`,
 * and `openSheet(source)`.
 */
(function () {
  if (window.omdOffer) return;

  var html = document.documentElement;
  // The side cart writes the count into its own markup on every render.
  var COUNT_SOURCE = 'side-cart-drawer [data-offer-test-count]';

  function arm() {
    return html.getAttribute('data-offer-arm') || '';
  }

  function readInitial() {
    var n = parseInt(html.getAttribute('data-offer-count'), 10);
    return isNaN(n) ? 0 : n;
  }

  var state = window.omdOffer = {
    n: readInitial(),
    arm: arm,
    openSheet: openSheet,
    sync: sync
  };

  // 1. The painting count.
  function sync(n) {
    n = Math.max(0, Math.floor(Number(n) || 0));
    state.n = n;
    html.setAttribute('data-offer-count', String(n));
    html.setAttribute('data-offer-n', String(Math.min(n, 3)));
  }

  function readCount() {
    var node = document.querySelector(COUNT_SOURCE);
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      return typeof data.n === 'number' ? data.n : null;
    } catch (error) {
      return null;
    }
  }

  window.addEventListener('side-cart:updated', function () {
    var n = readCount();
    if (n !== null) sync(n);
  });

  // 2. The sheet. A native <dialog>: Escape closes it, Tab and Shift-Tab
  // stay inside it.
  var opener = null;

  function sheet() {
    return document.getElementById('OfferTestSheet');
  }

  function openSheet(source) {
    var dialog = sheet();
    if (!dialog || !arm() || dialog.open) return false;
    opener = document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    html.classList.add('offer-sheet-is-open');
    return true;
  }

  function closeSheet() {
    var dialog = sheet();
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  // Tab and Shift-Tab cycle through the open sheet's controls. A modal
  // dialog alone lets focus leave it for the browser's own controls.
  function keepFocus(dialog, event) {
    var items = Array.prototype.filter.call(dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (item) {
      return !item.disabled && item.getClientRects().length > 0;
    });
    var active = document.activeElement;
    if (!items.length) {
      event.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (!dialog.contains(active) || active === dialog || (event.shiftKey && active === first) || (!event.shiftKey && active === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  }

  // Escape closes the sheet even when another script cancels the key (the
  // .com country selector cancels every Escape at document level).
  window.addEventListener('keydown', function (event) {
    var dialog = sheet();
    if (!dialog || !dialog.open) return;
    if (event.key === 'Escape') closeSheet();
    else if (event.key === 'Tab') keepFocus(dialog, event);
  }, true);

  document.addEventListener('close', function (event) {
    if (event.target !== sheet()) return;
    html.classList.remove('offer-sheet-is-open');
    if (opener && typeof opener.focus === 'function' && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var dialog = sheet();
    if (dialog && target === dialog) {
      // A tap on the backdrop lands on the dialog itself, outside its panel.
      closeSheet();
      return;
    }
    if (target.closest('[data-offer-sheet-close]')) {
      event.preventDefault();
      closeSheet();
      return;
    }

    var trigger = target.closest('[data-offer-sheet-open]');
    if (trigger) {
      if (openSheet(trigger.getAttribute('data-offer-sheet-open'))) event.preventDefault();
      return;
    }

    // 3. The collection tile is a link to the cart. With paintings in the
    // cart the side cart opens on it, as for any cart link. With none, it
    // opens the sheet instead, and the side cart must not see the tap.
    var tile = target.closest('[data-offer-tile]');
    if (tile && arm()) {
      var toSheet = state.n === 0;
      if (toSheet && openSheet('tile')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, true);

  function start() {
    // The page may come from the back-forward cache with an older count. The
    // side cart refreshes then and fires `side-cart:updated`.
    sync(state.n);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
